(() => {
  const linkSelector = '.header__icon--wishlist';
  let lastCount = null;
  let syncing = false;

  const parseCount = (value) => {
    const n = parseInt(String(value || '').replace(/[^\d]/g, ''), 10);
    return Number.isFinite(n) ? n : null;
  };

  const countFromSquareHeader = () => {
    const root = document.querySelector('.Vtl-WishlistHeader, .Vtl-WishlistHeaderWrapper, #vitals-wishlist-header');
    if (!root) return null;

    const labeled = parseCount(root.getAttribute('aria-label'));
    if (labeled != null) return labeled;

    const badge = root.querySelector('[class*="Count"], [class*="Badge"], [data-count]');
    if (badge) {
      const n = parseCount(badge.textContent) ?? parseCount(badge.getAttribute('data-count'));
      if (n != null) return n;
    }

    const text = (root.textContent || '').trim();
    return /^\d+$/.test(text) ? parseInt(text, 10) : null;
  };

  const countFromStorage = () => {
    try {
      for (let i = 0; i < localStorage.length; i += 1) {
        const key = localStorage.key(i);
        if (!key || !/wish|vtl|vital/i.test(key)) continue;
        const parsed = JSON.parse(localStorage.getItem(key) || 'null');
        if (Array.isArray(parsed)) return parsed.length;
        if (parsed && Array.isArray(parsed.items)) return parsed.items.length;
        if (parsed && Array.isArray(parsed.products)) return parsed.products.length;
        if (parsed && typeof parsed.count === 'number') return parsed.count;
      }
    } catch (error) {
      return null;
    }
    return null;
  };

  const applyCount = (count) => {
    const n = Math.max(0, Number(count) || 0);
    if (n === lastCount) return;
    lastCount = n;
    document.querySelectorAll(linkSelector).forEach((link) => {
      const bubble = link.querySelector('.wishlist-count-bubble');
      const numberEl = link.querySelector('[data-wishlist-count]');
      if (!bubble || !numberEl) return;
      numberEl.textContent = n > 99 ? '99+' : String(n);
      bubble.hidden = n < 1;
      const label = link.dataset.wishlistLabel || '';
      link.setAttribute('aria-label', n > 0 ? `${label} (${n})` : label);
    });
  };

  const sync = () => {
    if (syncing) return;
    syncing = true;
    const count = countFromSquareHeader() ?? countFromStorage();
    if (count != null) applyCount(count);
    syncing = false;
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest('[class*="Wishlist"], [class*="wishlist"]')) return;
      window.setTimeout(sync, 500);
    },
    { passive: true }
  );

  window.addEventListener('storage', sync);

  const placeCardHearts = () => {
    document.querySelectorAll('.Vtl-CollectionCardWidget, [class*="CollectionCardWidget"]').forEach((widget) => {
      if (widget.closest('.card__wishlist-mount')) return;
      const id =
        widget.getAttribute('data-product-id') ||
        widget.querySelector('[data-product-id]')?.getAttribute('data-product-id') ||
        (String(widget.className).match(/Id-(\d+)/) || [])[1];
      if (!id) return;
      const mount = document.querySelector(`.card__wishlist-mount[data-product-id="${id}"]`);
      if (mount) mount.appendChild(widget);
    });
  };

  const start = () => {
    sync();
    placeCardHearts();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.setTimeout(start, 800);
})();
